import { render, staticRenderFns } from "./RectangleTinplateBadge.vue?vue&type=template&id=23fed42d&scoped=true&"
import script from "./RectangleTinplateBadge.vue?vue&type=script&lang=js&"
export * from "./RectangleTinplateBadge.vue?vue&type=script&lang=js&"
import style0 from "./RectangleTinplateBadge.vue?vue&type=style&index=0&id=23fed42d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fed42d",
  null
  
)

component.options.__file = "RectangleTinplateBadge.vue"
export default component.exports